
import { Button } from "@/components/ui/button";
import { ChevronUp, ChevronDown } from "lucide-react";

interface WeightControlsProps {
  onIncrement: () => void;
  onDecrement: () => void;
  disabled: boolean;
}

export const WeightControls = ({ onIncrement, onDecrement, disabled }: WeightControlsProps) => {
  return (
    <div className="absolute right-1 top-1/2 -translate-y-1/2 flex flex-col">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-4 w-4 p-0 hover:bg-[#00C1D6]/20 text-gray-300 hover:text-white disabled:opacity-30"
        onClick={onIncrement}
        disabled={disabled}
      >
        <ChevronUp className="h-3 w-3" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-4 w-4 p-0 hover:bg-[#00C1D6]/20 text-gray-300 hover:text-white disabled:opacity-30"
        onClick={onDecrement}
        disabled={disabled}
      >
        <ChevronDown className="h-3 w-3" />
      </Button>
    </div>
  );
};
